'use client';

import React, { useMemo } from 'react';

import { ExternalLink } from '@uikit';

import { ArrowRight2 } from '@uikit/icons/ArrowRight2';
import LinkIcon from '@uikit/icons/Link';

import NextLink from '@shared/common/components/NextLink';
import { useRewardPoolsFeaturedAndDailyInfiniteQuery } from '@shared/hooks/query/rewardPools';

import RewardPoolsAllPools from './RewardPoolsAllPools';
import RewardPoolsSlider from './RewardPoolsSlider';
import RewardPoolsStats from './RewardPoolsStats';

const RewardPoolsPage = () => {
  const { data: featuredRewardPools } = useRewardPoolsFeaturedAndDailyInfiniteQuery();

  const allRewardPools = useMemo(
    () => featuredRewardPools?.pages.flatMap((page) => page.pools) || [],
    [featuredRewardPools],
  );

  const title = 'Reward Pools';

  return (
    <>
      <div className="relative">
        <div className="absolute w-full top-0 left-0 h-56 gradient-page -z-[1]" />
        <main className="msq-container">
          <nav
            aria-label="Breadcrumb"
            className="breadcrumbs breadcrumbs-sm mb-2 xl:mb-1 xl:breadcrumbs-md"
          >
            <NextLink href="/" className="breadcrumbs-link">
              Discover
            </NextLink>
            <ArrowRight2 aria-hidden="true" className="breadcrumbs-separator" />
            <NextLink href="/reward-pools" className="breadcrumbs-link" aria-current="page">
              {title}
            </NextLink>
          </nav>

          <header className="flex max-xl:flex-col xl:items-center xl:justify-between gap-4 mb-6 xl:mb-8">
            <h1 className="text-[2.5rem] leading-[1.2] font-semibold ">{title}</h1>

            <ExternalLink
              href="https://docs.magic.store/for-users/reward-pools"
              className="msq-btn msq-btn-md msq-btn-secondary max-xl:w-full"
            >
              How it Works
              <LinkIcon className="msq-btn-icon msq-btn-icon-right" />
            </ExternalLink>
          </header>

          <RewardPoolsStats />

          {!!allRewardPools.length && (
            <>
              <h2 className="text-2xl leading-7 text-[#09090B] font-semibold mb-4 xl:mb-6 xl:text-[2rem] xl:leading-10">
                Featured & Daily Pools
              </h2>

              <RewardPoolsSlider
                className="mb-8 xl:mb-14"
                rewardPools={allRewardPools.slice(0, 2)}
              />
            </>
          )}

          <RewardPoolsAllPools />
        </main>
      </div>
    </>
  );
};

export default RewardPoolsPage;
